import type { ProductModel } from '@bytel/leviator';

import { setMixedCartEnabled } from './mixed-cart';
import { getSessionData, setSessionVariable } from './storage';

const _storageKey = 'ftth3Clics';

interface Ftth3ClicsStorageValue {
    data: boolean;
}

export function isFtth3Clics(faiOffer: ProductModel): boolean {
    const value = getSessionData<Ftth3ClicsStorageValue>(_storageKey);
    return value?.data === true && faiOffer.metadata?.technology === 'FTTH';
}

export function stopFtth3Clics(): void {
    setSessionVariable(
        _storageKey,
        JSON.stringify({
            data: false,
        }),
    );
    setMixedCartEnabled(true);
}
